/**
 * All API urls and other constants will reside here.
 * It is always a good idea to keep a local copy of all API response to
 * keep your app working for UI changes and
 * make it independent of network requirements.
 *
 * They need to be categorised and grouped together as:
 *  - Actual endpoints url.
 *  - Local data .json file path.
 * At a moment only one group should be uncommented.
 *
 * Other way to deal with this is to name every json file as per your service endpoint and use a basepath variable.
 * Toggle this basePath variable between "actual-domain.com/" or "/data/".
 */

// Actual endpoints. Uncomment below section to use actual data.
// export const GET_ALL_USERS = () => `https://jsonplaceholder.typicode.com/users`;
// export const GET_USER_DETAILS = (id) => `https://jsonplaceholder.typicode.com/users/${id}`;

// Local endpoints. Uncomment below section to use dummy local data.

let endpoint = process.env.REACT_APP_URL_LINK;
let GET_LOAN_DETAILS_URL = `${endpoint}/LoanLookup/getLoanDetails`;
let GET_LOAN_AND_BORROWERS_URL = `${endpoint}/LoanLookup/getLoanAndBorrowers`;
let GET_BORROWER_AND_LOANS_URL = `${endpoint}/LoanLookup/getBorrowerAndLoans`;
let POST_LOAN_DETAILS_URL = `${endpoint}/Payment/process-payment`;

const GET_LOAN_DETAILS = () => `${GET_LOAN_DETAILS_URL}`;
const GET_LOAN_AND_BORROWERS = () => `${GET_LOAN_AND_BORROWERS_URL}`;
const GET_BORROWER_AND_LOANS = () => `${GET_BORROWER_AND_LOANS_URL}`;
const POST_LOAN_DETAILS = () => `${POST_LOAN_DETAILS_URL}`;

export {
  GET_LOAN_DETAILS,
  POST_LOAN_DETAILS,
  GET_LOAN_AND_BORROWERS,
  GET_BORROWER_AND_LOANS,
};
